import { render, staticRenderFns } from "./automation-document-classification.vue?vue&type=template&id=77ef5ad8"
import script from "./automation-document-classification.vue?vue&type=script&lang=ts"
export * from "./automation-document-classification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports